"use strict";

var _classCallCheck = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/site/repository/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var THREE = require("three");

var Surface =
/*#__PURE__*/
function () {
  function Surface() {
    _classCallCheck(this, Surface);

    this.manager = new THREE.LoadingManager();
    this.texloader = new THREE.TextureLoader(this.manager);
    this.texturesRoot = process.env.TEXTURES_ROOT || 'https://kwcws3d.blob.core.windows.net/cdn/textures/';
    this.populateTextures();
    this.populateMaterials();
  }

  _createClass(Surface, [{
    key: "populateMaterials",
    value: function populateMaterials() {
      var texloaderCube = new THREE.CubeTextureLoader();
      var reflect = "".concat(this.texturesRoot, "mirror.jpg");
      var cubemaps = [reflect, reflect, reflect, reflect, reflect, reflect];
      var textureReflect = texloaderCube.load(cubemaps);
      var texture = this.getTexture('textureGranitGrey');
      texture.generateMipmaps = true;
      texture.minFilter = THREE.LinearMipmapLinearFilter;
      texture.magFilter = THREE.LinearFilter; // const maxAnisotropy = renderer.capabilities.getMaxAnisotropy();
      // texture.anisotropy = maxAnisotropy;

      this.materials = {
        test: new THREE.MeshPhongMaterial({
          color: 'green',
          wireframe: true,
          transparent: true,
          opacity: 0.5,
          vertexColors: THREE.FaceColors
        }),
        testFace: new THREE.MeshPhongMaterial({
          color: 'blue',
          transparent: true,
          opacity: 0.5,
          vertexColors: THREE.FaceColors
        }),
        stainlessSteel: new THREE.MeshPhongMaterial({
          envMap: textureReflect,
          reflectivity: 0.8,
          color: 'white',
          emissive: 0x222222
        }),
        stainlessSteelDoubleSided: new THREE.MeshPhongMaterial({
          envMap: textureReflect,
          reflectivity: 0.8,
          color: 'white',
          emissive: 0x222222,
          side: THREE.DoubleSide
        }),
        stainlessSteelWhite: new THREE.MeshPhongMaterial({
          envMap: textureReflect,
          reflectivity: 0.2,
          specular: 0xffffff,
          shininess: 10,
          color: 0xffffff
        }),
        plainBlack: new THREE.MeshPhongMaterial({
          envMap: textureReflect,
          reflectivity: 0,
          color: 0x000000,
          emissive: 0x000000
        }),
        white: new THREE.MeshPhongMaterial({
          envMap: textureReflect,
          reflectivity: 0.2,
          specular: 0xffffff,
          shininess: 10,
          color: 0xffffff
        }),
        lightGray: new THREE.MeshPhongMaterial({
          envMap: textureReflect,
          reflectivity: 0.4,
          map: this.getTexture('textureGranitGrey'),
          specular: 0xffffff,
          shininess: 20,
          color: 0xffffff,
          emissive: 0x444444 // Slightly increased emissive color

        }),
        blackWhite: new THREE.MeshPhongMaterial({
          envMap: textureReflect,
          map: this.getTexture('textureGranitBlackWhite'),
          reflectivity: 0.6,
          specular: 0xcccccc,
          shininess: 20,
          color: 0xffffff,
          emissive: 0x444444 // Slightly increased emissive color

        }),
        black: new THREE.MeshPhongMaterial({
          envMap: textureReflect,
          reflectivity: 0.6,
          map: this.getTexture('textureGranitBlack'),
          specular: 0xcccccc,
          shininess: 20,
          color: 0xffffff,
          emissive: 0x444444 // Slightly increased emissive color

        }),
        floorTileWhite: new THREE.MeshPhongMaterial({
          color: 'white',
          normalMap: this.getTexture('textureTileWhiteNormal'),
          emissive: 0x000000,
          specular: 0xaaaaaa,
          transparent: true,
          opacity: 0.95,
          shininess: 100
        }),
        floorTileBlack: new THREE.MeshPhongMaterial({
          transparent: true,
          opacity: 0.95,
          name: 'floorTileBlack',
          map: this.getTexture('textureFloorTileBlack'),
          normalMap: this.getTexture('textureTileWhiteNormal'),
          normalScale: new THREE.Vector2(0.5, 0.5),
          specular: 0x555555,
          shininess: 80,
          color: 0xffffff
        }),
        wallWhite: new THREE.MeshPhongMaterial({
          color: 0xffffff,
          normalMap: this.getTexture('textureTileWhiteNormal'),
          shininess: 20,
          emissive: 0x222222,
          specular: 0xaaaaaa
        }),
        wallBlack: new THREE.MeshPhongMaterial({
          normalScale: new THREE.Vector2(0.5, 0.5),
          map: this.getTexture('textureTileBlack'),
          name: 'wallBlack',
          normalMap: this.getTexture('textureTileBlackNormal'),
          specular: 0x555555,
          shininess: 80,
          color: 0xffffff
        }),
        miranit: new THREE.MeshPhongMaterial({
          envMap: textureReflect,
          reflectivity: 0.8,
          color: 'white',
          emissive: 0x222222
        }),
        mirror: new THREE.MeshPhongMaterial({
          color: 'white',
          envMap: textureReflect,
          reflectivity: 0.95
        }),
        mirrorBack: new THREE.MeshPhongMaterial({
          color: 'white'
        })
      };
    }
  }, {
    key: "populateTextures",
    value: function populateTextures() {
      this.textures = {
        textureGradient: this.texloader.load("".concat(this.texturesRoot, "lines.jpg"), function (tex) {
          tex.wrapS = tex.wrapT = THREE.RepeatWrapping;
          tex.offset.set(0, 0);
          tex.repeat.set(1, 1);
        }),
        textureGranitGrey: this.texloader.load("".concat(this.texturesRoot, "Granit_Hellgrau.jpg"), function (tex) {
          tex.wrapS = tex.wrapT = THREE.MirroredRepeatWrapping; // THREE.RepeatWrapping;

          tex.offset.set(0, 0);
          tex.repeat.set(3, 6);
        }),
        textureGranitBlackWhite: this.texloader.load("".concat(this.texturesRoot, "Granit_Schwarz_Weiss.jpg"), function (tex) {
          tex.wrapS = tex.wrapT = THREE.RepeatWrapping;
          tex.offset.set(0, 0);
          tex.repeat.set(3, 6);
        }),
        textureGranitBlack: this.texloader.load("".concat(this.texturesRoot, "Granit_Schwarz.jpg"), function (tex) {
          tex.wrapS = tex.wrapT = THREE.RepeatWrapping;
          tex.offset.set(0, 0);
          tex.repeat.set(3, 6);
        }),
        textureTileBlackNormal: this.texloader.load("".concat(this.texturesRoot, "fliese_schwarz_normal.jpg"), function (tex) {
          tex.wrapS = tex.wrapT = THREE.RepeatWrapping;
          tex.offset.set(0, 0.5);
          tex.repeat.set(0.7, 0.7);
        }),
        textureTileBlack: this.texloader.load("".concat(this.texturesRoot, "fliese_schwarz.jpg"), function (tex) {
          tex.wrapS = tex.wrapT = THREE.RepeatWrapping;
          tex.offset.set(0, 0.5);
          tex.repeat.set(0.7, 0.7);
        }),
        textureTileWhiteNormal: this.texloader.load("".concat(this.texturesRoot, "fliese_white_quad_normal.jpg"), function (tex) {
          tex.wrapS = tex.wrapT = THREE.RepeatWrapping;
          tex.offset.set(0, 0);
          tex.repeat.set(3, 3);
        }),
        textureFloorTileBlack: this.texloader.load("".concat(this.texturesRoot, "granit_schwarz_boden.jpg"), function (tex) {
          tex.wrapS = tex.wrapT = THREE.RepeatWrapping;
          tex.offset.set(0, 0);
          tex.repeat.set(3, 3);
        })
      };
    }
  }, {
    key: "getTexture",
    value: function getTexture() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'textureGranitGrey';
      return this.textures[name];
    }
  }, {
    key: "getMaterial",
    value: function getMaterial() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'test';
      // Should check if it exists, else return test one I guess
      return this.materials[name];
    }
  }]);

  return Surface;
}();

exports.Surface = Surface;
exports.surface = new Surface();
exports.default = Surface;